import { render, staticRenderFns } from "./third-goods-list.vue?vue&type=template&id=76ee48e5&scoped=true&"
import script from "./third-goods-list.vue?vue&type=script&lang=js&"
export * from "./third-goods-list.vue?vue&type=script&lang=js&"
import style0 from "./third-goods-list.vue?vue&type=style&index=0&id=76ee48e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ee48e5",
  null
  
)

export default component.exports